import { render, staticRenderFns } from "./crm-setting-dropdown.vue?vue&type=template&id=11b89186&"
import script from "./crm-setting-dropdown.vue?vue&type=script&lang=js&"
export * from "./crm-setting-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./crm-setting-dropdown.vue?vue&type=style&index=0&id=11b89186&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports